<div class="vtr-hardware-components">
	<!-- Defines the header component -->
	<div class="col col-12 row header-content">
		<div class="col col-12">
			<vtr-hardware-scan-finished-header></vtr-hardware-scan-finished-header>
		</div>
	</div>

	<div class="body-content">
		<div class="row px-0">
			<div class="col-12 header">
				<h2 id="hwscan-components-title" role="heading" class="header2">{{ 'hardwareScan.hardwareComponents' | translate }}</h2>

				<!-- Link Export Results -->
				<vtr-ui-hyperlink-button
					*ngIf="isFeatureExportAvailable"
					class="export-log-btn"
					linkId="view-results-export-log-btn"
					linkRole="button"
					hyperlinkStyle="xs-300-blue-lighter"
					imgIconSrc="{{ getExportIcon( !isExportLogAvailable() ) }}"
					[isDisabled]="!isExportLogAvailable()"
					(hyperlinkClick)="exportLog()"
					[label]="'hardwareScan.exportLog' | translate">
				</vtr-ui-hyperlink-button>
			</div>
		</div>

		<!-- Defines the last test list executed -->
		<div class="row">
			<div class="col">
				<div class="hardware-lists-container">
					<vtr-widget-hardware-scan-item
						[items]="item.items"
						[resultCodeText]="resultCodeText"
						[detailsText]="detailsText"
						[isLoadingDone]="true"
						[isViewLog]="true">
					</vtr-widget-hardware-scan-item>
				</div>
			</div>
		</div>
	</div>
</div>
